// Angular
import { Component, HostListener, Inject, OnDestroy, OnInit } from '@angular/core';

// Libraries
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

// Models
import { AppCleanup } from '../../models';

@Component({
	selector: 'confirm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent extends AppCleanup implements OnInit, OnDestroy {
	icon: string;
	title: string = 'Attention';
	message: string = this.translateService.instant('GENERIC.CONFIRM');
	htmlMessage: string;
	action: string = 'Confirm';
	cancelText: string = 'Cancel';
	hideAction: boolean = false;
	passwordMatch: string; // Password that needs to match
	password: string; // Password user types
	isValid = true;
	showPassword: boolean = false;

	constructor(
		private dialogRef: MatDialogRef<ConfirmDialogComponent>,
		@Inject(MAT_DIALOG_DATA) private data: ConfirmDialogModel,
		private translateService: TranslateService
	) {
		super();
	}

	@HostListener('window:keyup.Enter', ['$event'])
	onDialogClick(event: KeyboardEvent) {
		this.confirm();
	}

	ngOnInit() {
		if (this.data?.icon) {
			this.icon = this.data?.icon;
		}

		if (this.data?.title) {
			this.title = this.data?.title;
		}

		if (this.data?.message) {
			this.message = this.data?.message;
		}

		if (this.data?.htmlMessage) {
			this.htmlMessage = this.data?.htmlMessage;
			this.message = null;
		}

		if (this.data?.password) {
			this.passwordMatch = this.data?.password;
		}

		if (this.data?.action) {
			this.action = this.data?.action;
		}

		if (this.data.hideAction) {
			this.hideAction = this.data.hideAction;
		}

		if (this.data.cancelText) {
			this.cancelText = this.data.cancelText;
		}
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	cancel() {
		this.dialogRef.close(false);
	}

	confirm() {
		if (this.passwordMatch) {
			if (this.isPasswordValid()) {
				this.isValid = true;
				this.dialogRef.close(true);
			} else {
				this.isValid = false;
			}
		} else {
			this.dialogRef.close(true);
		}
	}

	isPasswordValid() {
		if (this.password === this.passwordMatch) {
			return true;
		}
		return false;
	}
}

export class ConfirmDialogModel {
	icon?: string;
	title?: string;
	message?: string;
	htmlMessage?: string;
	password?: string;
	action?: string;
	hideAction?: boolean;
	cancelText?: string;
}
